export default function SidebarMoreIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 6L18 8L6 8L6 6L18 6ZM18 16L18 18L6 18L6 16L18 16ZM18 13.0001L18 11.0001L6 11.0001L6 13.0001L18 13.0001Z"
        fill="var(--text-secondary-color)"
      />
    </svg>
  );
}
